import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=24eca2ba&scoped=true"
import script from "./Estoque.vue?vue&type=script&lang=js"
export * from "./Estoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eca2ba",
  null
  
)

export default component.exports